import { Container } from "@material-ui/core";
import React from "react";
import PageTitle from "../../../components/pageTitle/PageTitle";


const SystemAlertPage = () => {

    return (
        <Container>
            <PageTitle
                pageTitle={`System Alerts`}
                showBreadcrumb={[
                    { label: "Home", to: "/" },
                ]}
                BreadCrumbCurrentPageTitle={"System Alerts"}
                showLastSeen={true}
            />
            <div className="sectionBox">

            </div>
        </Container>
    )
}
export default SystemAlertPage;